import React from "react";
import { EditOutlined } from "@mui/icons-material";

interface PartnerSuccessMetricsProps {
  isForSharing: boolean;
  partnerSuccessMetricsData: any;
  setPartnerSuccessMetricsData: any;
  sectionVisibility: any;
  setSectionVisibility: any;
  primaryColor?: string;
  accentColor?: string;
  canWrite?: boolean;
  canDelete?: boolean;
}

const PartnerSuccessMetrics: React.FC<PartnerSuccessMetricsProps> = ({
  isForSharing,
  partnerSuccessMetricsData,
  setPartnerSuccessMetricsData,
  sectionVisibility,
  setSectionVisibility,
  primaryColor,
  accentColor,
  canWrite = false,
  canDelete = false,
}) => {
  return (
    <div style={{ padding: "0px " }}>
      <div
        id="partner-success-metrics"
        style={{
          backgroundColor: primaryColor,
          color: "white",
          padding: "20px 60px",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            minHeight: "45px",
          }}
          className={
            sectionVisibility?.["partner-success-metrics"] && !isForSharing
              ? "section-header"
              : ""
          }
        >
          {sectionVisibility?.["partner-success-metrics"] && !isForSharing && (
            <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  border: "none",
                  background: "transparent",
                  margin: 0,
                  height: "auto",
                  wordBreak: "break-word",
                }}
              >
                Partner Success Metrics
              </h3>
            </div>
          )}
          {!isForSharing && (
            <button
              onClick={() => {
                if (setSectionVisibility) {
                  setSectionVisibility((prev: any) => ({
                    ...prev,
                    "partner-success-metrics": !prev["partner-success-metrics"],
                  }));
                }
              }}
              className={
                sectionVisibility?.["partner-success-metrics"]
                  ? "toggle-section-button"
                  : ""
              }
              style={{
                position: "absolute",
                right: -40,
                cursor: canWrite ? "pointer" : "not-allowed",
                width: "147px",
                height: "42px",
                border: "none",
                borderRadius: "8px",
                backgroundColor: "#fff",
                color: canWrite ? "#000000" : "rgba(16, 16, 16, 0.3)",
                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                padding: "6px 24px",
                fontSize: "15px",
                fontFamily: "Roboto, sans-serif",
              }}
              disabled={!canWrite}
            >
              {sectionVisibility?.["partner-success-metrics"]
                ? "Show Section"
                : "Hide Section"}
            </button>
          )}
        </div>

        {!sectionVisibility?.["partner-success-metrics"] && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px",
                position: "relative",
              }}
              className="partner-success-metrics-title"
            >
              {partnerSuccessMetricsData.isTitleEditing && !isForSharing ? (
                <input
                  type="text"
                  value={partnerSuccessMetricsData.title || ""}
                  autoFocus
                  onBlur={() => {
                    setPartnerSuccessMetricsData((prev: any) => ({
                      ...prev,
                      isTitleEditing: false,
                    }));
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "white",
                    outline: "none",
                    fontSize: "30px",
                    fontWeight: "bold",
                    textAlign: "center",
                    width: `${partnerSuccessMetricsData.title.length + 1}ch`,
                    flex: 1,
                    fontFamily: "Roboto, sans-serif",
                  }}
                  onChange={(e) => {
                    setPartnerSuccessMetricsData((prev: any) => ({
                      ...prev,
                      title: e.target.value,
                    }));
                  }}
                  maxLength={40}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "30px",
                      fontWeight: "500",
                      textAlign: "center",
                      flex: 1,
                      width: "auto",
                      maxWidth: "450px",
                      cursor: "default",
                      wordBreak: "break-word",
                    }}
                    title={partnerSuccessMetricsData.title}
                  >
                    {partnerSuccessMetricsData.title}
                  </h3>
                  {!isForSharing && (
                    <button
                      style={{
                        border: "none",
                        cursor: canWrite ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "50%",
                        padding: "4px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                      onClick={() => {
                        setPartnerSuccessMetricsData((prev: any) => ({
                          ...prev,
                          isTitleEditing: !prev.isTitleEditing,
                        }));
                      }}
                      disabled={!canWrite}
                    >
                      <EditOutlined fontSize="small" />
                    </button>
                  )}
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginTop: "30px",
              }}
              className="partner-success-metrics-cards"
            >
              {partnerSuccessMetricsData?.metrics?.map(
                (metric: any, index: number) => (
                  <div
                    key={metric.id}
                    style={{
                      width: "18%",
                      padding: "0px 30px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "start",
                      paddingTop: "10px",
                      borderRight:
                        index !== partnerSuccessMetricsData.metrics.length - 1
                          ? "1px solid white"
                          : "none",
                    }}
                    className="partner-success-metrics-card"
                  >
                    {metric.isValueEditing && !isForSharing ? (
                      <input
                        type="text"
                        value={metric.value || ""}
                        autoFocus
                        onBlur={() => {
                          setPartnerSuccessMetricsData((prev: any) => ({
                            ...prev,
                            metrics: prev.metrics.map((m: any) =>
                              m.id === metric.id
                                ? { ...m, isValueEditing: false }
                                : m
                            ),
                          }));
                        }}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "white",
                          outline: "none",
                          fontSize: "30px",
                          fontWeight: "bold",
                          textAlign: "center",
                          width: `${metric.value.length + 1}ch`,
                          fontFamily: "Roboto, sans-serif",
                        }}
                        onChange={(e) => {
                          setPartnerSuccessMetricsData((prev: any) => ({
                            ...prev,
                            metrics: prev.metrics.map((m: any) =>
                              m.id === metric.id
                                ? { ...m, value: e.target.value }
                                : m
                            ),
                          }));
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          justifyContent: "center",
                        }}
                      >
                        <h2
                          style={{
                            fontSize: "30px",
                            fontWeight: "bold",
                            margin: 0,
                          }}
                        >
                          {metric.value}
                        </h2>
                        {!isForSharing && (
                          <button
                            style={{
                              border: "none",
                              cursor: canWrite ? "pointer" : "not-allowed",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "50%",
                              padding: "4px",
                              fontFamily: "Roboto, sans-serif",
                            }}
                            onClick={() => {
                              setPartnerSuccessMetricsData((prev: any) => ({
                                ...prev,
                                metrics: prev.metrics.map((m: any) =>
                                  m.id === metric.id
                                    ? {
                                        ...m,
                                        isValueEditing: !m.isValueEditing,
                                      }
                                    : m
                                ),
                              }));
                            }}
                            disabled={!canWrite}
                          >
                            <EditOutlined fontSize="small" />
                          </button>
                        )}
                      </div>
                    )}
                    <p>{metric.label}</p>
                  </div>
                )
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PartnerSuccessMetrics;
